import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GoogleAuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      // Get authorization code from URL query params
      const code = searchParams.get('code');
      const error = searchParams.get('error');

      if (error) {
        console.error('Google OAuth error:', error);
        navigate('/auth?error=' + error, { replace: true });
        return;
      }

      if (!code) {
        console.error('No authorization code found');
        navigate('/auth?error=no_code', { replace: true });
        return;
      }

      try {
        // Exchange the code with backend
        const response = await axios.get(`${API}/auth/google/exchange`, {
          params: { code },
          withCredentials: true
        });

        const userData = response.data;
        
        if (userData.error) {
          navigate('/auth?error=' + userData.error, { replace: true });
          return;
        }

        setUser(userData);

        // Redirect based on onboarding status
        if (userData.onboarding_completed) {
          navigate('/dashboard', { replace: true, state: { user: userData } });
        } else {
          navigate('/onboarding', { replace: true, state: { user: userData } });
        }
      } catch (error) {
        console.error('Google auth exchange error:', error);
        navigate('/auth?error=auth_failed', { replace: true });
      }
    };

    processGoogleAuth();
  }, [navigate, setUser, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-[#E06D53] border-t-transparent rounded-full animate-spin" />
        <p className="text-slate-600 dark:text-slate-400 font-medium">Completing Google sign-in...</p>
      </div>
    </div>
  );
}
